import React from 'react';
import { Modal } from 'react-bootstrap';
import { useModalContext } from '../contexts/ModalContext';

const ModalsContainer = () => {
  const { modals, removeModal } = useModalContext();

  return (
    <>
      {modals.map((modal) => (
        <Modal
          key={modal.id}
          show={modal.show}
          size={modal.size}
          onHide={() => removeModal(modal.id)}
          onExited={() => removeModal(modal.id)}
          data-bs-theme={modal.theme}
        >
          <Modal.Header closeButton>
            <Modal.Title>{modal.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modal.body}</Modal.Body>
          {modal.footer && <Modal.Footer>{modal.footer}</Modal.Footer>}
        </Modal>
      ))}
    </>
  );
};

export default ModalsContainer;
